// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/user_info/merge_duplicate_users_record_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoMergeDuplicateUsersRecordDatatable } from "./constants";
import type {
  AppsUserInfoMergeDuplicateUsersRecordDatatableParams,
  AppsUserInfoMergeDuplicateUsersRecordDatatableResult,
} from "./types";

export const getDataTableAppsUserInfoMergeDuplicateUsersRecordDatatable = reactQueryTableFetcherAdapter(
  appsUserInfoMergeDuplicateUsersRecordDatatable,
  (
    signal: AbortSignal,
    { appGroupId, query, limit = 20, start = 0 }: AppsUserInfoMergeDuplicateUsersRecordDatatableParams
  ): Promise<AppsUserInfoMergeDuplicateUsersRecordDatatableResult> => {
    return fetch(
      "/apps/user_info/merge_duplicate_users_record_datatable",
      "GET",
      {
        limit,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
